import faker from 'faker';
import moment from 'moment';

export default Array(10)
    .fill(0)
    .map((_, index) => {
        return({
            fornecedor: (index == 0) ? '' : faker.company.companyName(),
            numeroContrato: (index == 0) ? '' : faker.random.number({min: 2000, max: 3000}),
            ct: (index == 0) ? '' : faker.address.stateAbbr(),
            contrato: faker.random.number({min: 1000, max: 50000, precision: 0.01}).toFixed(2),
            medido: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
            saldo: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
            inicio: (index == 0) ? '' : moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            termino: (index == 0) ? '' : moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            diasRestantes: (index == 0) ? '' : faker.random.number({min: 50, max: 200}),
            quantidadeAditivo: faker.random.number({min: 0, max: 5}),
            area: (index == 0) ? '' : faker.address.stateAbbr(),
            gestor: (index == 0) ? '' : faker.name.firstName(),
            tipoServico: (index == 0) ? '' : faker.hacker.abbreviation()
        })
    });